<template>
  <div class="homepage">
    <!-- Hero Banner -->
    <section class="hero fade-in">
      <img src="@/assets/images/ffjb1.jpg" alt="Banner principal sobre tecnologia e climatização" class="hero-image" />
      <div class="hero-text">
        <h1>FFJB Soluções</h1>
        <h2>Soluções Técnicas Inteligentes para sua Casa, Empresa ou Indústria</h2>
        <p>Trabalhamos com eletrônica, eletricidade civil e industrial, climatização, automação, manutenção de máquinas, elevadores, portas automáticas, eletromecânica e telecomunicações</p>
      </div>
    </section>

    <!-- Principais Serviços -->
    <section class="principais-servicos slide-up">
      <h2>Principais Serviços</h2>
      <div class="servicos-grid">
        <div class="servico-card" v-for="(servico, index) in principaisServicos" :key="index" @click="goTo(servico.rota)">
          <img :src="getImage(servico.img)" :alt="servico.titulo" />
          <h3>{{ servico.titulo }}</h3>
        </div>
      </div>
    </section>

    <!-- Todos os serviços -->
    <section class="services slide-up">
      <div class="service-grid">
        <div class="service-card" v-for="(servico, index) in servicos" :key="index">
          <img :src="getImage(servico.img)" :alt="servico.titulo" />
          <h3>{{ servico.titulo }}</h3>
          <p>{{ servico.descricao }}</p>
        </div>
      </div>
    </section>

    <!-- Galeria -->
    <section class="gallery-section zoom-in">
      <h2>Nossos Serviços em Ação</h2>
      <div class="gallery">
        <img :src="getImage('1000.jpg')" alt="Instalação de ar-condicionado" />
        <img :src="getImage('indu.jpg')" alt="Sistema de automação industrial" />
        <img :src="getImage('manut.jpg')" alt="Serviços de manutenção" />
        <img :src="getImage('ffjbporta.jpg')" alt="Manutenção de portas industriais" />
        <img :src="getImage('ffjbsol.jpg')" alt="Soluções técnicas em campo" />
        <img :src="getImage('ffjbac.jpg')" alt="Equipamento de climatização" />
      </div>
    </section>

    <!-- Por que escolher a FFJB -->
    <section class="why-choose-us fade-in">
      <h2>Por que escolher a FFJB?</h2>
      <div class="why-choose-grid">
        <div class="why-choose-item" v-for="(item, index) in whyChooseItems" :key="index">
          <img :src="getImage(item.img, true)" :alt="item.titulo" />
          <h3>{{ item.titulo }}</h3>
          <p>{{ item.descricao }}</p>
        </div>
      </div>
    </section>

    <!-- Call to Action -->
    <section class="cta slide-up">
      <h2>Solicite seu orçamento agora mesmo</h2>
      <p>Entre em contato com nossa equipe pelo WhatsApp para tirar dúvidas ou agendar uma visita técnica.</p>
      <a href="https://wa.me/244922488863?text=Olá,%20gostaria%20de%20um%20orçamento" target="_blank" class="cta-button">
        Fale com um especialista
      </a>
    </section>

    <!-- WhatsApp flutuante -->
    <a href="https://wa.me/244922488863?text=Olá,%20gostaria%20de%20mais%20informações" target="_blank" class="whatsapp-float" aria-label="Abrir WhatsApp">
      <img src="https://upload.wikimedia.org/wikipedia/commons/5/5e/WhatsApp_icon.png" alt="Ícone do WhatsApp" />
    </a>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  data() {
    return {
      principaisServicos: [
        { titulo: 'Eletrônica', img: 'eletro.jpg', rota: 'eletronica' },
        { titulo: 'Eletricidade Civil e Industrial', img: 'eletri.jpg', rota: 'eletricidade' },
        { titulo: 'Manutenção de Elevadores', img: 'elevad.jpg', rota: 'elevadores' },
        { titulo: 'Esteiras Elétricas', img: 'este.jpg', rota: 'esteiras' },
        { titulo: 'Máquinas e Motores', img: 'maquin.jpg', rota: 'manutencao' },
        { titulo: 'Climatização e Frio', img: 'climat.jpg', rota: 'climatizacao' },
        { titulo: 'Automação Industrial', img: 'auto.jpg', rota: 'automacao' },
        { titulo: 'Desenvolvimento de Projetos de Eletromecânica', img: 'eletromeca.jpg', rota: 'eletromecanica' },
        { titulo: 'Portas Automáticas', img: 'ports.jpg', rota: 'portas' },
        { titulo: 'Telecomunicações', img: 'telecomunica.jpg', rota: 'telecomunicacao' },

      ],
      servicos: [
        {
          titulo: 'Frio Industrial',
          descricao: 'Instalação e manutenção de câmaras frigoríficas, túneis de congelamento e sistemas de refrigeração.',
          img: 'ffjbfrio.jpg',
        },
        {
          titulo: 'Climatização',
          descricao: 'Projetos residenciais e comerciais com conforto térmico e eficiência energética.',
          img: 'ffjbmidea.jpg',
        },
        {
          titulo: 'Automação Industrial',
          descricao: 'Soluções inteligentes para processos industriais automatizados e eficientes.',
          img: 'ffjbmaq.jpg',
        },
        {
          titulo: 'Eletricidade',
          descricao: 'Instalações elétricas seguras e otimizadas para residências e indústrias.',
          img: 'eletricidade.jpg',
        },
      ],
      whyChooseItems: [
        {
          titulo: 'Equipe Altamente Qualificada',
          descricao: 'Profissionais com vasta experiência em suas áreas, garantindo excelência em cada projeto.',
          img: 'https://i.pinimg.com/736x/87/72/6d/87726d2456712e0327f40ef2142d371b.jpg',
        },
        {
          titulo: 'Soluções Modernas e Eficientes',
          descricao: 'Utilizamos as tecnologias mais avançadas para oferecer soluções inovadoras e eficazes.',
          img: 'https://i.pinimg.com/736x/86/b7/8e/86b78ea0e5f3e42536039cf952e52365.jpg',
        },
        {
          titulo: 'Atendimento Personalizado',
          descricao: 'Nosso compromisso é entender suas necessidades e oferecer o melhor suporte.',
          img: 'ffjbpub.jpg',
        },
        {
          titulo: 'Experiência Comprovada no Setor',
          descricao: 'Anos de atuação com resultados comprovados em diversos projetos de sucesso.',
          img: 'https://i.pinimg.com/736x/26/06/3d/26063d1f3d231aa541c3cadd64291cca.jpg',
        },
      ],
    };
  },
  methods: {
    goTo(path) {
      this.$router.push(`/servicos/${path}`);
    },
    getImage(imgPath, allowExternal = false) {
      // Se a imagem começar com http, retorna direto
      if (allowExternal && (imgPath.startsWith('http://') || imgPath.startsWith('https://'))) {
        return imgPath;
      }
      try {
        // Tenta resolver o caminho da imagem local
        return require(`@/assets/images/${imgPath}`);
      } catch (e) {
        console.warn(`Imagem não encontrada: ${imgPath}`, e);
        return '';
      }
    },
  },
};
</script>


<style scoped>
/* Animações */
.fade-in {
  animation: fadeIn 1.2s ease-in-out;
}

.slide-up {
  animation: slideUp 1s ease-out;
}

.zoom-in {
  animation: zoomIn 1s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(40px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes zoomIn {
  from {
    transform: scale(0.9);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* Layout base */
.homepage {
  background-color: #0b0b0b;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
  margin: 0;
  padding: 0;
}

/* Hero */
.hero {
  position: relative;
  height: 300px;
  overflow: hidden;
}

.hero-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  padding: 20px;
  border-radius: 10px;
  text-align: center;
}

.scale-in {
  animation: scaleIn 0.8s ease forwards;
}

h2 {
  text-align: center;
}

cta1 h3 {
  font-size: 2rem;
  margin-bottom: 1rem;
  text-align: center;
}

.principais-servicos {
  
  padding: 40px 20px;
  background: #000000;
  text-align: center;
}

.principais-servicos h2 {
  font-size: 2rem;
  margin-bottom: 20px;
  color: #ffffff;
}

.servicos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  justify-items: center;
}

.servico-card {
  background: #f9f9f9;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
  text-align: center;
  padding-bottom: 10px;
}

.servico-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

.servico-card img {
  width: 100%;
  height: 160px;
  object-fit: cover;
}

.servico-card h3 {
  font-size: 1.1rem;
  padding: 12px;
  color: #333;
}
@keyframes scaleIn {
  0% {
    opacity: 0;
    transform: scale(0.95);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.hero-text h1 {
  font-size: 2.5rem;
}

.hero-text p {
  font-size: 1.2rem;
}

/* Services */
.services {
  padding: 40px 20px;
  background-color: #161616;
  text-align: center;
}

.services h2 {
  margin-bottom: 20px;
  font-size: 2rem;
}

.service-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
}

.service-card {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.service-card:hover {
  transform: translateY(-5px);
}

.service-card img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
}

/* Gallery */
.gallery-section {
  padding: 40px 20px;
  background: #121111;
  text-align: center;
  color: #fff;
}

.gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}

.gallery img {
  width: 100%;
  max-width: 320px;
  border-radius: 10px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
}

.gallery img:hover {
  transform: scale(1.05);
}

/* Why Choose */
.why-choose-us {
  padding: 40px 20px;
  background: #1c1d1e;
  text-align: center;
  color: #fff;
}

.why-choose-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.why-choose-item {
  background: #000000;
  color: #ffffff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.why-choose-item:hover {
  transform: translateY(-5px);
}

.why-choose-item img {
  width: 100%;
  height: 160px;
  object-fit: cover;
  border-radius: 8px;
}

/* CTA */
.cta {
  background: #0056b3;
  color: #fff;
  text-align: center;
  padding: 40px 20px;
}

.cta-button {
  background: #fff;
  color: #25d366;
  padding: 15px 30px;
  border-radius: 50px;
  font-weight: bold;
  text-decoration: none;
  display: inline-block;
  margin-top: 20px;
  transition: background 0.3s ease;
}

.cta-button:hover {
  background: #000000;
}

/* WhatsApp Button */
.whatsapp-float {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #25d366;
  border-radius: 50%;
  padding: 10px;
  z-index: 999;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
}

.whatsapp-float:hover {
  transform: scale(1.1);
}

.whatsapp-float img {
  width: 40px;
  height: 40px;
}

/* Responsividade */
@media (max-width: 768px) {
  .hero-text h1 {
    font-size: 2rem;
  }

  .cta1 {
    padding: 30px 20px;
  }

  .hero-text p {
    font-size: 1rem;
  }

  .cta-button {
    width: 100%;
  }
}
</style>
